import React, { Fragment, useEffect, useRef, useState } from 'react';
import moment from 'moment';

const getHeaderCSRF = () => {
  return {
    "Content-Type": "application/json",
    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
      ?.content,
  }
}

const FakeRating = ({ value }) => {
  // Calculate the number of full stars
  const fullStars = Math.floor(value);
  // Check if there is a half star
  const hasHalfStar = value % 1 >= 0.5;

  // Generate an array of star icons
  const stars = Array.from({ length: 5 }, (_, index) => {
    // Determine the star's class name based on its state (full, half, or empty)
    let className = 'star';
    if (index < fullStars) {
      className += ' full';
    } else if (index === fullStars && hasHalfStar) {
      className += ' half';
    } else {
      className += ' empty';
    }

    return (
      <span key={index} className={className}>
      </span>
    );
  });

  return <div className="utf_star_rating_section" data-nojquery="true" title={value}>{stars}</div>;
}
const getLanguageName = (languageCode) => {
  const languageDisplayNames = new Intl.DisplayNames([navigator.language], { type: 'language' });
  return languageDisplayNames.of(languageCode);
};
const getTranslate = async (text) => {
  const resp = await fetch(`/translate`, {
    method: 'POST',
    headers: getHeaderCSRF(),
    body: JSON.stringify({
      text,
      to: window.navigator.language
    })
  });
  return await resp.json();
}

const Review = (props) => {
  const { listing, review } = props;
  const [isHelpful, setIsHelpful] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [translation, setTranslation] = useState(null);
  const [isTranslated, setIsTranslated] = useState(false);

  const sendHelpful = async (type) => {
    setIsLoading(true)
    fetch(`/listing/${listing.slug}/reviews/${review.id}/helpful`, {
      method: 'POST',
      headers: getHeaderCSRF(),
      body: JSON.stringify({ type })

    }).then((resp) => {
      return resp;
    }).then((resp) => {
      setIsHelpful(type);
      setIsLoading(false);
    }).catch((error) => {
      console.log('error', error);
      setIsHelpful(!isHelpful)
      setIsLoading(false);
    })
  }
  const handleToggleHelpful = (e, type = 'helpful') => {
    e.preventDefault();
    if (isHelpful) return null;
    sendHelpful(type);
  }
  const imgWrapperRef = useRef();
  useEffect(() => {
    // if (imgWrapperRef.current && window.jQuery) {
    //   console.log('trigger')
    //   window.jQuery(imgWrapperRef.current).magnificPopup({
    //     type: 'image',
    //     delegate: 'a.utf_gallery',
    //     fixedContentPos: true,
    //     fixedBgPos: true,
    //     overflowY: 'auto',
    //     closeBtnInside: false,
    //     preloader: true,
    //     removalDelay: 0,
    //     mainClass: 'mfp-fade',
    //     gallery: {
    //       enabled: true,
    //       tCounter: ''
    //     }
    //   });
    // }
  }, []);
  const handleTranslate = (e) => {
    e.preventDefault();
    if (isLoading) return false;
    setIsLoading(true);
    getTranslate(review.message).then((resp) => {
      console.log('getTranslate', resp);
      setTranslation(resp);
      setIsTranslated(true);
      setIsLoading(false);
    }).catch((error) => {
      console.log('error', error);
      setIsLoading(false);
    })
  }
  const handleShowOriginal = (e) => {
    e.preventDefault();
    setIsTranslated(false);
  }
  const decoratedMessage = translation && isTranslated ? translation.text : review.message;
  const helpfulCount = isHelpful === 'helpful' ? (+review.helpful + 1) : +review.helpful;
  const unHelpfulCount = isHelpful === 'unhelpful' ? (+review.unhelpful + 1) : +review.unhelpful
  return (
    <Fragment>
      <div style={{ background: 'var(--card-bg)', border: '1px solid var(--border)', borderRadius: '12px', padding: '24px', marginBottom: '16px' }}>
        <div className="utf_comment_content" style={{ margin: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <div style={{ fontWeight: '700', color: 'var(--white)', fontSize: '15px' }}>
              {review.display_name}
            </div>
            <div style={{ fontSize: '13px', color: 'var(--white40)' }}>
              {moment(review.created_at).fromNow()}
            </div>
          </div>

          <div style={{ marginBottom: '12px' }}>
            <FakeRating value={review.rating} />
          </div>

          <div className="review-text" style={{ margin: 0, fontSize: '14px', color: 'var(--white70)', lineHeight: '1.6', whiteSpace: 'pre-line' }}>
            {decoratedMessage}
          </div>

          {
            review.images && review.images.length > 0 && <div className="review-images utf_gallery_container" ref={imgWrapperRef} style={{ marginTop: '16px' }}>
              {
                review.images.map((image, idx) => (
                  <a key={`${idx}-${image.url}`} href={`${image.url}`} className="utf_gallery"><img src={`${image.url}`} alt="" /></a>
                ))
              }
            </div>
          }

          <div className='rate-reviews' style={{ marginTop: '20px', display: 'flex', gap: '12px', alignItems: 'center' }}>
            <a href="#" disabled={isLoading || isHelpful}
              onClick={e => handleToggleHelpful(e, 'helpful')}
              title="Helpful"
              className={`rate-review ${isHelpful === 'helpful' ? 'active' : ''} ${(isLoading || (isHelpful && isHelpful !== 'helpful')) ? 'disabled' : ''}`}>
              <i className="fa fa-thumbs-up"></i>
              Helpful
              {
                helpfulCount > 0 && <span style={{ marginLeft: '4px' }}>({helpfulCount})</span>
              }
            </a>

            {
              !isTranslated && review.message && <a href="#" className='btn-translate' onClick={handleTranslate} style={{ opacity: 0.7 }}>
                See translation
              </a>
            }
            {
              isTranslated && review.message && <a href="#" className='btn-translate' onClick={handleShowOriginal} style={{ opacity: 0.7 }}>
                <small>Translated by Google ・ <strong>See original ({getLanguageName(translation.from)})</strong></small>
              </a>
            }
          </div>
        </div>
      </div>
    </Fragment>
  )
}
export default Review;
